var tools = {
    createAttribute: function (attr) {
        return {
            id: tools.idGeter(attr.attr_id, attr.attr_value_id),
            key: attr.attr_id,
            keyalias: attr.attr_name,
            value: attr.attr_value_id,
            valuealias: attr.attr_value,
            disable: false,
            selected: false,
            friends: {}
        };
    },
    idGeter: function (key, value) {
        return key + '-' + value;
    },
    inArray: function (array, judger) {
        var res = null;
        $.each(array, function (i, item) {
            if (judger(item)) {
                res = item;
                return false;
            }
        });
        return res;
    }
};

function Hash () {
    this.data = {};
    this.minPrice = 0;
    this.maxPrice = 0;
    this.minSharedPrice = 0;
    this.maxSharedPrice = 0;
    this.minMarketPrice = 0;
    this.maxMarketPrice = 0;
    this.minCut = 0;
    this.maxCut = 0;
    this.totalStock = 0;
    this.sourceData = {};
    this.skus = {};
    this.stocks = {};
}

Hash.prototype = {
    initData: function (data) {
        var that = this;
        that.sourceData = data;

        if (data.length === 0) {
            that.minPrice = 0;
            that.maxPrice = 0;
            that.minAppPrice = 0;
            that.maxAppPrice = 0;
            that.minMarketPrice = 0;
            that.maxMarketPrice = 0;
            that.minCut = 0;
            that.maxCut = 0;
            that.Shared = 0;
            that.maxSharedPrice = 0;
        } else {
            that.minPrice = data[0].price;
            that.maxPrice = data[0].price;
            that.minAppPrice = data[0].appPrice;
            that.maxAppPrice = data[0].appPrice;
            that.minMarketPrice = data[0].marketPrice;
            that.maxMarketPrice = data[0].marketPrice;
            that.minCut = data[0].cut;
            that.maxCut = data[0].cut;
            that.minSharedPrice = data[0].share_price;
            that.maxSharedPrice = data[0].share_price;
        }

        $.each(data, function (i, row) {
            that.minPrice = Math.min(that.minPrice, row.price);
            that.maxPrice = Math.max(that.maxPrice, row.price);
            that.minAppPrice = Math.min(that.minAppPrice, row.appPrice);
            that.maxAppPrice = Math.max(that.maxAppPrice, row.appPrice);
            that.minSharedPrice = Math.min(
                that.minSharedPrice,
                row.share_price
            );
            that.maxSharedPrice = Math.max(
                that.maxSharedPrice,
                row.share_price
            );

            that.minMarketPrice = Math.min(
                that.minMarketPrice,
                row.marketPrice
            );
            that.maxMarketPrice = Math.max(
                that.maxMarketPrice,
                row.marketPrice
            );
            that.minCut = Math.min(that.minCut, row.cut);
            that.maxCut = Math.max(that.maxCut, row.cut);
            that.totalStock += row.number;
            var spec_id = row.spec_id,
                _key = $
                    .map(row.attributes, function (o) {
                        return '[' + o.attr_id + '-' + o.attr_value_id + ']';
                    })
                    .join('');
            that.stocks[_key] = row;
            $.each(row.attributes, function (i, attr) {
                var id = tools.idGeter(attr.attr_id, attr.attr_value_id);
                var attrObject = null;
                if (that.has(id)) {
                    attrObject = that.get(id);
                } else {
                    attrObject = tools.createAttribute(attr);
                    attrObject.index = i;
                    that.data[id] = attrObject;
                }
                if (attr.attr_id === spec_id) {
                    // attrObject.imgs = row.imgs;
                    attrObject.imgs = row.images;
                }
                that.addAttrFriends(attrObject, row.attributes);
            });
            that.skus[row.sku_id] = row;
        });
    },
    reloadStock: function (data) {
        var that = this;
        $.each(data, function (sku_id, number) {
            that.skus[sku_id].number = number;
        });
    },
    addAttrFriends: function (attrObject, friends) {
        var myFriends = attrObject.friends;
        $.each(friends, function (i, attr) {
            var id = tools.idGeter(attr.attr_id, attr.attr_value_id);
            // 去除自己
            if (
                myFriends[id] === undefined &&
                attr.attr_id !== attrObject.key
            ) {
                myFriends[id] = 1;
            }
        });
    },
    get: function (id) {
        return this.data[id];
    },
    clear: function () {
        this.data = {};
        this.minPrice = 0;
        this.maxPrice = 0;
        this.minAppPrice = 0;
        this.maxAppPrice = 0;
        this.minMarketPrice = 0;
        this.maxMarketPrice = 0;
        this.minCut = 0;
        this.maxCut = 0;
        this.totalStock = 0;
        this.sourceData = {};
        this.skus = {};
    },
    has: function (id) {
        return this.data[id] !== undefined;
    },
    toGroups: function () {
        var array = [];
        $.each(this.data, function (id, attr) {
            var group = tools.inArray(array, function (item) {
                return attr.key === item.key;
            });
            if (group === null) {
                array.push({
                    key: attr.key,
                    keyalias: attr.keyalias,
                    list: [attr]
                });
            } else {
                group.list.push(attr);
            }
        });
        return array;
    },
    replaceAttrs: function (groups) {
        var that = this;
        $.each(groups, function (i, group) {
            $.each(group.list, function (j, attr) {
                that.data[attr.id] = attr;
            });
        });
    },
    freeAll: function () {
        $.each(this.data, function (id, attr) {
            attr.disable = false;
        });
    },
    disable: function (list) {
        $.each(list, function (i, attr) {
            if (attr.selected === false) {
                attr.disable = true;
            }
        });
    },
    querySourceData: function (key) {
        key = key.join('').replace(/\\/g, '');
        return this.stocks[key];
    },
    getPriceRange: function () {
        if (this.minPrice === this.maxPrice) {
            return this.minPrice;
        } else {
            return this.minPrice + '－' + this.maxPrice;
        }
    },
    getAppPriceRange: function () {
        if (this.minAppPrice === this.maxAppPrice) {
            return this.minAppPrice;
        } else {
            return this.minAppPrice + '－' + this.maxAppPrice;
        }
    },
    getMarketPriceRange: function () {
        if (this.minMarketPrice === this.maxMarketPrice) {
            return this.minMarketPrice;
        } else {
            return this.minMarketPrice + '－' + this.maxMarketPrice;
        }
    },
    getSharedPriceRange: function () {
        if (this.minSharedPrice === this.maxSharedPrice) {
            return this.minSharedPrice;
        } else {
            return this.minSharedPrice + '－' + this.maxSharedPrice;
        }
    },
    getCutRange: function () {
        if (this.minCut === this.maxCut) {
            return this.minCut;
        } else {
            return this.minCut + '－' + this.maxCut;
        }
    },
    getTotalStock: function () {
        return this.totalStock;
    }
};

export default new Hash();



// WEBPACK FOOTER //
// ./src/js_modules/attribute/hash.js